exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-legacy-box {\n  background: white;\n  padding: 16px;\n  margin: 16px;\n  text-align: center;\n  font-size: 18px; }\n\n.main-legacy-box h3 {\n  font-weight: bold; }\n\n.main-legacy-box p {\n  font-weight: 300; }\n\n.main-legacy-box button {\n  text-transform: none;\n  padding: 0 16px; }\n", ""]);

// exports
